import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { TOOLTIP_TEXT } from '@Const/tooltip-text'
import React from 'react'

const RoleTooltip = () => <CustomToolTip place="top" type="?" info={TOOLTIP_TEXT.createWork.writerRole} />

export default RoleTooltip
